(function() {

    'use strict';

    angular.module('Services').service('MarketPlaceConfigTableService', MarketPlaceConfigTableService);

    MarketPlaceConfigTableService.$inject = ['MarketPlaceService', 'TableLiteFactory', 'CommonService', '$filter'];

    function MarketPlaceConfigTableService(MarketPlaceService, TableLiteFactory, CommonService, $filter) {

        var tableStructure = {
            headers: [
                {
                    label: 'MARKETPLACE', // Column Name
                    viewName: 'marketplaceType',
                    filterName: 'marketplaceType',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'MARKETPLACE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'Website',
                    viewName: 'marketplaceURL',
                    filterName: 'company.website',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'CLIENT',
                    viewName: 'client',
                    filterName: 'company.name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
            ],
            data: []
        };
        const tableActions = new TableLiteFactory(tableStructure,
            {
                serviceCallback: MarketPlaceService.getConfiguration,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = tableActions.evaluateFilter;
        const sendRequest = tableActions.sendRequest;

        function buildTableData(data, pagination, filters, filter) {
            /*** START - Building of Data ***/

            tableActions.initializeTableData(data);
            angular.forEach(data.content, function(row) {
                row.marketplaceType = row.marketplaceType ? $filter('firstUpper')(row.marketplaceType) : 'N/A';
                row.name            = row.name ? $filter('firstUpper')(row.name) : 'N/A';
                row.marketplaceURL  = row.attributes && row.attributes.url || 'N/A';
                row.client          = row.company && row.company.name || 'N/A';
                row.href            = '/marketplaces/view/' + row.id;
                
                tableStructure.data.push(row);
            });
            /*** END - Building of Data ***/
        }
        return tableStructure;
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/MarketPlaceConfigTableService.js